import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import { RoleMasterService } from "../../services";
import { ConfirmDialog, WarnDialog } from '../../components/shared';
import 'date-fns';
import { Box, Button, Backdrop, TextField, Card, CircularProgress, Container, Grid, InputLabel } from '@material-ui/core';
import { Formik, Form, useFormik } from 'formik';
import { makeStyles} from '@material-ui/core/styles';
import { ContentSave, Delete } from 'mdi-material-ui';
import 'react-medium-image-zoom/dist/styles.css'
import allowAction from '../../helpers/allowAction';


const useStyles = makeStyles((theme) => ({
    pageTitleDiv: {
        marginTop: 20,
    },
    pageTitle: {
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 0,
        fontSize: 18,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase'
    },
    formCard: {
        display: 'flex',
        marginTop: 10,
        marginBottom: 10,
        paddingTop: 12,
        paddingBottom: 12,
        backgroundColor: theme.palette.background.paper,
    },
    innerGrid: {

    },
    form: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formFieldContainer: {
        display: 'flex',
        width: '46%',
        marginRight: '1rem',
        marginLeft: '1rem',
        marginBottom: 8,
        marginTop: 8
    },
    inputLabel: {
        marginLeft: '1rem',
        marginRight: '1rem',
        width: '8rem',
        fontSize: 14,
        zIndex: 1000,
        lineHeight: 1.75,
        textTransform: 'uppercase',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center'
    },
    textField: {
        width: 260,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    prefix: {
        width: 100,
        marginRight: 5
    },
    pictureButtonText: {
        color: theme.palette.type === 'light' ? theme.palette.text.secondary : theme.palette.background.paper,
        fontWeight: 'bold'
    },
    validationCondition: {
        textTransform: 'none',
    },
    alertIcon: {
        color: theme.palette.error.main
    },
    checkIcon: {
        color: theme.palette.success.main
    },
    tabCard: {
        display: 'flex',
        marginTop: 6,
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.secondary
    },
    saveButton: {
        marginRight: 10,
        padding: 8,
        width: 90,
        alignSelf: 'center'
    },
    deleteButton: {
        marginLeft: 10,
        padding: 8,
        width: 90,
        alignSelf: 'center',
        backgroundColor: theme.palette.error.main,
        color: 'white'
    },
    cancelButton: {
        padding: 8,
        width: 90,
        alignSelf: 'center'
    },
    table: {
        backgroundColor: theme.palette.background.paper,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
}));

function nullToString(obj) {
    for (var i in obj) {
        if (obj[i] === null) {
            obj[i] = ''
        }
        if (obj['rolId'] === '') {
            obj['rolId'] = Number(obj.sequence)
        }
    }
    return obj;
}

export default function RoleMasterCreate(props) {
    const dataPassedFromTable = useSelector((state) => state.roleMaster.formDataFromTableRoleMaster);
    const isEditingRole = useSelector((state) => state.roleMaster.isEditingRole);
    const isCreatingRole = useSelector((state) => state.roleMaster.isCreatingRole);
    const allRoles = useSelector((state) => state.roleMaster.allRoles);
    const history = useHistory();
    const classes = useStyles();

    const [formData, setFormData] = useState(nullToString(dataPassedFromTable))
    //Loading
    const [isLoading, setIsLoading] = useState(false);

    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const [warnDialog, setWarnDialog] = useState({ isOpen: false, title: '', subTitle: '' });

    const formik = useFormik({
        initialValues: formData,
        onSubmit: async (values) => {
            if (isCreatingRole && allRoles.length > 0 && allRoles.findIndex(r => r.rolName.toUpperCase() === values.rolName.toUpperCase()) > -1) {
                setWarnDialog({
                    isOpen: true,
                    title: 'Data Warning',
                    subTitle: <><Box component="div">Role name must be unique.  Role "{values.rolName}" already exists.</Box></>,
                })
                return;
            }
                try {
                await RoleMasterService.saveRole(values)
                history.push('/admin/role-master/home')
            } catch (e) {
                console.log(e.message)
            }

        },
    });

    //if page reload, send user back to home
    if (!isEditingRole && !isCreatingRole) {
        history.push('/admin/role-master/home')
    }

    const handleDeleteRole = async () => {
        setConfirmDialog({
            isOpen: true,
            title: `Are you sure you want to delete ${formData.rolName} from the system?`,
            subTitle: <><Box component="div">{`This operation will not perform successfully if any users are assigned to ${formData.rolName}`}</Box></>,
            onConfirm: async () => {
                try {
                    let response = await RoleMasterService.deleteRole(formData)
                    if (response) {
                        history.push('/admin/role-master/home')
                    }
                } catch (e) {
                    console.log(e.message)
                }
                setConfirmDialog({ ...confirmDialog, isOpen: false })
            }

        })
    }

    if (isLoading) {
        return (
            <Backdrop className={classes.backdrop} open={isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>)
    }
    return (
        <>
            <Container>
                <div className={classes.pageTitleDiv}>
                    <h2 className={classes.pageTitle}>
                        {isCreatingRole ?
                            <> Create New Role </>
                            :
                            <> Edit Role </>
                        }
                    </h2>
                </div>

                <Grid container spacing={3}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', marginTop: 10, marginBottom: 10 }}>
                        {allowAction("50201", "edit") ?
                            <Button className={classes.saveButton} startIcon={<ContentSave />} onClick={formik.handleSubmit} size='small' variant='contained' color='primary'>
                                Save
                    </Button>
                            : null}
                        <Button className={classes.cancelButton} onClick={() => history.push('/admin/role-master/home')} size='small' variant='contained' color='default'>
                            Cancel
                    </Button>
                        {isEditingRole && allowAction("50201", "delete") ?
                            <Button className={classes.deleteButton} startIcon={<Delete style={{ color: 'white' }} />} onClick={handleDeleteRole} size='small' variant='contained'>
                                Delete
                    </Button>
                            : ''}
                    </div>
                    <Card className={classes.formCard}>
                        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.innerGrid}>
                            <Formik>
                                <Form
                                    className={classes.form}
                                    onSubmit={formik.onSubmit}
                                >
                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Name:
                                   </InputLabel>
                                        <TextField
                                            id="rolName"
                                            name="rolName"
                                            className={classes.textField}
                                            variant='outlined'
                                            size="small"
                                            value={formik.values.rolName}
                                            onChange={formik.handleChange} />
                                    </div>

                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Description:
                                   </InputLabel>
                                        <TextField
                                            id="rolDescription"
                                            name="rolDescription"
                                            //className={classes.textField}
                                            fullWidth
                                            variant='outlined'
                                            size="small"
                                            value={formik.values.rolDescription}
                                            onChange={formik.handleChange} />
                                    </div>

                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            ID:
                                   </InputLabel>
                                        <TextField
                                            id="rolId"
                                            name="rolId"
                                            disabled={true}
                                            className={classes.textField}
                                            variant='outlined'
                                            size="small"
                                            value={formik.values.rolId}
                                            onChange={formik.handleChange} />
                                    </div>
                                </Form>
                            </Formik>
                        </Grid>
                    </Card>
                </Grid>

            </Container >
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
            <WarnDialog
                warnDialog={warnDialog}
                setWarnDialog={setWarnDialog}
            />
            <Backdrop className={classes.backdrop} open={!formik.values}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};